import React, { Component } from 'react'
import SideMenu from '../admin/SideMenu';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Carousel } from 'react-responsive-carousel';
import {Accordion, AccordionItem} from 'react-sanfona';
import TopMenu from '../admin/TopBar';
import { base, appDatabasePrimaryFunctions } from '../../base';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import '../../styles/css/AdminMain.css';
import swal from 'sweetalert2';
import DatePicker from '../utils/DatePicker';
import Countdown from "react-countdown";
import {convertTimeStampToHumanReadable, getSnapshotFromEndpoint, findFirstAndLastName, validUrl, valueDoesExist} from '../utils/HelpfulFunction';
import {sortPlayersForAdmin} from "myshared";
import Papa from 'papaparse';
import classNames from 'classnames';

class SetUpGame extends Component {
    constructor(props) {
        super(props);
        this.state = {
          select: {},
          ticket_select: {},
          ticketList: [],
          users: [],
          questionsList: [],
          schedule_game_time: new Date(),
          schedule_game_time_end: new Date(new Date().setHours(23, 59, 0, 0)),
          itemsAdded: [],
          rewardsAdded: [],
          rewardToAdd: '',
          rewardAmount: 0,
          codes: false,
          codesArray: '',
          qrCodes: false,
          userAnswers: [],
          currentGameRewards: [],
          currentGame: null,
          modal: false,
            viewFutureGameModal: false,
            viewingFutureGame: null,
            expandedRewardCodes: {},
          timeLeft: 10,
          timeModal: false,
          gameName: null,
          userGameHistory: [],
          loading: true,
          wizardLocation: 'first',
          showStats: true,
          advanceSettings: false,
          gamesList: [],
          emailsToSend: {},
          randomOrder: false,
          editingGame: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.saveReward = this.saveReward.bind(this);
        this.timeModalToggle = this.timeModalToggle.bind(this);
    }

    componentDidMount() {
      const vm = this;
      this.revealQuestionListRef = base.bindToState(`revealQuestionList`, {
        context: this,
        state: 'questionsList',
        asArray: true
      });
      this.tenantVariablesRef = base.bindToState(`tenantVariables`, {
        context: this,
        state: 'tenantVariables',
      });
      this.userAnswersRef = appDatabasePrimaryFunctions.ref("userAnswers").on('value', function(snapshot){
        vm.setState({
          userAnswerCount: snapshot.numChildren()
        })
      })
      this.currentGameRef = base.syncState(`currentGame`, {
        context: this,
        state: 'currentGame',
        then(err){
          this.setState({
            loading: false,
          })
          if(!err){
            this.setGameToWatch(this.state.currentGame.id)
          }
        },
        onFailure(err){
          // console.log(err)
          this.setState({
            loading: false,
          })
        }
      })
      this.ticketListRef = base.bindToState(`rewardsList`, {
        context: this,
        state: 'ticketList',
        asArray: true
      });
    }

    async downloadUsers() {
      this.setState({ loading: true });

      const isMlbApp = process.env.REACT_APP_IS_MLB_TEAM === "true";
      const emailText = isMlbApp ? 'Okta' : 'Email';

      // 1) Define base headers
      const baseHeaders = [
        emailText,
        'First Name','Last Name','Username',
        'Other First Name','Other Last Name',
        'Zip Code','Street','City','State','Address',
        'Birthday','Phone Number','Social Handle',
        'Fan Response Text','Fan Response Text 2',
        'Short Text Response 1','Short Text Response 2',
        'Custom Dropdown','Custom Dropdown 2',
        'Opt-In','Opt-In 2','Opt-In 3','Opt-In 4',
        'YesNoQuestions','YesExplanation',
        'YesNoQuestions2','YesExplanation2',
        'How They Heard','User Image',
        'UTM Campaign','UTM Medium','UTM Source','SRC Code',
        'Correct Answers','Reward','Code',
        'Last Sign In','Sign Up Time','Play Time','Redeemed'
      ];

      // 2) Dynamic form-question headers/ids
      const formQuestionIds = [];
      const formQuestionHeaders = [];
      if (this.state.formQuestions) {
        this.state.formQuestions.forEach(fq => {
          formQuestionIds.push(fq.id);
          formQuestionHeaders.push(fq.text||'');
        });
      }

      // 3) Optional "Other"
      const hasOther = !!(this.state.tenantVariables && this.state.tenantVariables.otherResponse);

      // 4) Combine into finalHeaders
      let finalHeaders = [...baseHeaders, ...formQuestionHeaders];
      if (hasOther) finalHeaders.push('Other');

      try {
        // 5) Fetch raw data
        const [usersSnapshot] = await Promise.all([
          getSnapshotFromEndpoint('users', appDatabasePrimaryFunctions)
        ]);
        const users = usersSnapshot.exists() ? usersSnapshot.val() : {};
        const currentUsersState = await sortPlayersForAdmin(
            null, null,
            appDatabasePrimaryFunctions,
            this.state.currentGame,
            isMlbApp
        );

        // 6) Build dataForCsv rows
        const dataForCsv = currentUsersState[0].map(row => {
          const userData = users[row.uid] || {};
          const [first, last]      = findFirstAndLastName(userData.name);
          const [otherFirst, otherLast] = findFirstAndLastName(userData.otherName);

          // base columns
          const csvRow = [
            row.email||row.uid||'',
            first||'', last||'', userData.username||'',
            otherFirst||'', otherLast||'',
            userData.zipCode||'',
            userData.street||'',
            userData.city||'',
            userData.state||'',
            userData.address||'',
            userData.birthday||'',
            userData.phoneNumber||'',
            userData.socialHandle||'',
            userData.fanResponseToCollectTextInput||'',
            userData.fanResponseToCollectTextInput2||'',
            userData.textInputOne||'',
            userData.textInputTwo||'',
            userData.customDropdownInput||'',
            userData.customDropdownInput2||'',
            userData.optIn||'',
            userData.optInTwo||'',
            userData.optInThree||'',
            userData.optInFour||'',
            userData.yesNoQuestions||'',
            userData.yesExplanation||'',
            userData.yesNoQuestions2||'',
            userData.yesExplanation2||'',
            userData.howYouHeard||'',
            userData.userImage||'',
            userData.utmCampaign||'',
            userData.utmMedium||'',
            userData.utmSource||'',
            userData.srcCode||'',
            row.correctAnswers||'',
            row.rewardSent||'',
            row.code||'',
            userData.lastSignIn
                ? convertTimeStampToHumanReadable(userData.lastSignIn) : '',
            userData.signUpTime
                ? convertTimeStampToHumanReadable(userData.signUpTime) : '',
            row.timeStamp
                ? convertTimeStampToHumanReadable(row.timeStamp) : '',
            row.isRedeemed ? 'true' : ''
          ];

          // dynamic form-question columns
          formQuestionIds.forEach(qId => {
            let v = '';
            if (
                userData.form_responses &&
                (userData.form_responses[qId] === true ||
                    userData.form_responses[qId] === false)
            ) {
              v = String(userData.form_responses[qId]);
            } else {
              v = row[qId] || '';
            }
            csvRow.push(v);
          });

          // optional Other
          if (hasOther) {
            csvRow.push(userData.otherInput||'');
          }

          return csvRow;
        });

        // 7) Strip out all-empty columns
        const keepColumn = finalHeaders.map((_, idx) =>
            dataForCsv.some(row => row[idx] != null && row[idx] !== '')
        );
        const filteredHeaders = finalHeaders.filter((_, idx) => keepColumn[idx]);
        const filteredData    = dataForCsv.map(row =>
            row.filter((_, idx) => keepColumn[idx])
        );

        // 8) Generate CSV
        const csvString = Papa.unparse({
          fields: filteredHeaders,
          data: filteredData
        }, {
          quotes: true
        });

        // 9) Download via Blob
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url  = URL.createObjectURL(blob);
        const a    = document.createElement('a');
        a.href     = url;

        const dateGot = new Date(
            Date.now() - new Date().getTimezoneOffset()*60000
        ).toISOString().split('T')[0];

        a.download = `current_game_users_${dateGot}.csv`;
        a.target   = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

      } catch (err) {
        console.error('Error downloading users:', err);
      } finally {
        this.setState({ loading: false });
      }
    }

    detectUseOfIndex(text, index){
      text = text.replace(/%index%/g, index)
      return text
    }

    setGameToWatch(id){
      if(this.userGameHistoryRef){
        appDatabasePrimaryFunctions.ref('userGameHistory').off('value', this.userGameHistoryRef);
      }
      if(id){
        const vm = this;
        this.userGameHistoryRef = appDatabasePrimaryFunctions.ref("userGameHistory").orderByChild(id).equalTo(id).on('value', function(snapshot){
          vm.setState({
            userGameHistory: snapshot.numChildren()
          })
        })
      }
    }

    componentWillUnmount() {
      base.removeBinding(this.revealQuestionListRef);
      base.removeBinding(this.currentGameRef);
      base.removeBinding(this.ticketListRef);
      base.removeBinding(this.tenantVariablesRef);
      if(this.userGameHistoryRef){
        appDatabasePrimaryFunctions.ref('userGameHistory').off('value', this.userGameHistoryRef);
      }
      appDatabasePrimaryFunctions.ref('userAnswers').off('value', this.userAnswersRef);
    }

    editGame(gameToEdit){
      this.setState({
        modal: true,
        wizardLocation: "first",
        gameName: gameToEdit.gameName,
        schedule_game_time: new Date(gameToEdit.scheduleInfo.performAt),
        schedule_game_time_end: gameToEdit.scheduleInfo.endAt ? new Date(gameToEdit.scheduleInfo.endAt) : '',
        itemsAdded: gameToEdit.questions,
        noPrizes: !gameToEdit.rewards || gameToEdit.rewards.length === 0,
        editingGame: gameToEdit.id,
      }, () => {
        // Tier messaging reconstruction
        if(gameToEdit.tierMessaging){
          gameToEdit.tierMessaging.forEach((message, index) => {
            this.setState({
              [`winningWinnerHeader${index}`]: message.winningHeader,
              [`winningWinnerMessage${index}`]: message.winningMessage,
              [`winningMissedHeader${index}`]: message.winningMissedHeader,
              [`winningMissedMessage${index}`]: message.winningMissedMessage,
            });
          });
        }
        // Tier rewards reconstruction
        if(gameToEdit.rewards && Array.isArray(gameToEdit.rewards)){
          gameToEdit.rewards.forEach((rewardLevel) => {
            let rewardsAdded = [];
            for(const rewardId in rewardLevel){
              if(rewardId !== "totalRewards" && rewardId !== "totalRewardsUsed" && rewardId !== "randomPrizeOrder" && rewardId !== "answerLevel"){
                const rewardInLevel = rewardLevel[rewardId];
                if(typeof rewardInLevel === 'object' && rewardInLevel.rewardName){
                  const rewardToSave = this.state.ticketList.find(ticket => {
                    return (ticket.key === rewardInLevel.id || ticket.id === rewardInLevel.id);
                  });
                  rewardsAdded.push({
                    reward: rewardToSave,
                    amount: parseInt(rewardInLevel.amount),
                    codes: rewardInLevel.codes,
                    links: rewardInLevel.links,
                    codesArray: rewardInLevel.codesArray,
                    linksArray: rewardInLevel.linksArray,
                    pinsArray: rewardInLevel.pinsArray,
                    allElsePrize: rewardInLevel.allElsePrize
                  });
                }
              }
            }
            this.setState({
              [`rewardsAdded${rewardLevel.answerLevel}`]: rewardsAdded,
              [`randomOrder${rewardLevel.answerLevel}`]: rewardLevel.randomPrizeOrder,
            });
          });
        }
      });
    }

    async createGame(){
      const createGameObject = {};
      const gameId = this.state.editingGame || appDatabasePrimaryFunctions.ref().push().key;
      const tenantVariables = this.state.tenantVariables;
      const itemsAdded = this.state.itemsAdded;
      const futureGames = this.state.futureGamesList || [];
      const gameName = this.state.gameName;
      const gameStartTime = this.state.schedule_game_time;
      const gameEndTime = this.state.schedule_game_time_end;
      const currentTimeSeconds = Math.floor(Date.now());
      const inputtedDateSeconds = gameStartTime.getTime();
      const inputtedEndDateSeconds = gameEndTime.getTime();
      if(!gameName){
        swal({
            title: "Hold On!",
            text: "You must give the game a name!",
            type: 'warning',
            confirmButtonText: 'Ok'
          })
        return;
      }
      if(!inputtedDateSeconds){
        swal({
          title: "Hold On!",
          text: "You must enter a game start time!",
          type: 'warning',
          confirmButtonText: 'Ok'
        })
        return;
      }
      if(!inputtedEndDateSeconds){
        swal({
          title: "Hold On!",
          text: "You must enter a game end time!",
          type: 'warning',
          confirmButtonText: 'Ok'
        })
        return;
      }
      if(inputtedDateSeconds <= currentTimeSeconds){
        swal({
            title: "Hold On!",
            text: "The game start time must be in the future!",
            type: 'warning',
            confirmButtonText: 'Ok'
          })
        return;
      }
      if(inputtedEndDateSeconds <= inputtedDateSeconds){
        swal({
            title: "Hold On!",
            text: "The game end time must be after the start time!",
            type: 'warning',
            confirmButtonText: 'Ok'
          })
        return;
      }
      for(const fGameIndex in futureGames){
        const futureGame = futureGames[fGameIndex];
        if(futureGame.scheduleInfo && inputtedDateSeconds === futureGame.scheduleInfo.performAt && this.state.editingGame !== futureGame.id){
          swal({
            title: "Hold On!",
            text: "You already have a scheduled game at that time!",
            type: 'warning',
            confirmButtonText: 'Ok'
          })
          return;
        }
      }
      if(itemsAdded && itemsAdded.length < 1){
        swal({
            title: "Hold On!",
            text: `Not enough questions added. You need to add at least 1 to the game!`,
            type: 'warning',
            confirmButtonText: 'Ok'
          })
        return;
      }
      const rewardList = []
      const messaging_array = []
      for(let i = 0; i < itemsAdded.length + 1; i++){
        let index = i;
        let tiermessaging = {}
        tiermessaging.number_correct = index;
        let winningHeader = "You win!";
        let winningMessage = "Check your email for your prize!";
        let winningMissedHeader = "Nice Job!";
        let winningMissedMessage = "You got " + index.toString() + " correct! Unfortunately you didn't win a prize but try again soon!"
        if(index === 1){
          winningMessage = "You got it correct! Check your email for your prize!"
        } else if(index > 0){
          winningMessage = "You got " + index.toString() + " correct! Check your email for your prize!"
        }
        if(this.state['winningWinnerHeader' + index.toString()] != undefined){
          winningHeader = this.state['winningWinnerHeader' + index.toString()]
        } else if(tenantVariables.globalNoneCorrectPrizeHeader && tenantVariables.globalNoneCorrectPrizeHeader.length > 0 && index === 0) {
          winningHeader = this.detectUseOfIndex(tenantVariables.globalNoneCorrectPrizeHeader, index)
        } else if (tenantVariables.globalPrizeWonHeader && tenantVariables.globalPrizeWonHeader.length > 0) {
          winningHeader = this.detectUseOfIndex(tenantVariables.globalPrizeWonHeader, index)
        }
        if(this.state['winningWinnerMessage' + index.toString()] != undefined){
          winningMessage = this.state['winningWinnerMessage' + index.toString()]
        } else if(tenantVariables.globalNoneCorrectPrizeBody && tenantVariables.globalNoneCorrectPrizeBody.length > 0 && index === 0) {
          winningMessage = this.detectUseOfIndex(tenantVariables.globalNoneCorrectPrizeBody, index)
        } else if (tenantVariables.globalPrizeWonBody && tenantVariables.globalPrizeWonBody.length > 0) {
          winningMessage = this.detectUseOfIndex(tenantVariables.globalPrizeWonBody, index)
        }
        if(this.state['winningMissedHeader' + index.toString()] != undefined){
          winningMissedHeader = this.state['winningMissedHeader' + index.toString()]
        } else if (tenantVariables.globalNoPrizeHeader && tenantVariables.globalNoPrizeHeader.length > 0) {
          winningMissedHeader = this.detectUseOfIndex(tenantVariables.globalNoPrizeHeader, index)
        }
        if(this.state['winningMissedMessage' + index.toString()] != undefined){
          winningMissedMessage = this.state['winningMissedMessage' + index.toString()]
        } else if (tenantVariables.globalNoPrizeBody && tenantVariables.globalNoPrizeBody.length > 0) {
          winningMissedMessage = this.detectUseOfIndex(tenantVariables.globalNoPrizeBody, index)
        }

        tiermessaging.winningHeader = winningHeader;
        tiermessaging.winningMessage = winningMessage;
        tiermessaging.winningMissedHeader = winningMissedHeader;
        tiermessaging.winningMissedMessage = winningMissedMessage;

        const rewardsAdded = this.state['rewardsAdded' + i.toString()] || [];
        if(rewardsAdded.length !== 0 && !this.state.noPrizes){
          let totalAmount = 0;
          const readyToUploadPrizes = {};
          for(const rewardIndex in rewardsAdded){
            const generatedRewardId = appDatabasePrimaryFunctions.ref().push().key;
            const rewardVars = Object.assign({}, rewardsAdded[rewardIndex]);
            readyToUploadPrizes[generatedRewardId] = Object.assign({}, rewardVars.reward);
            readyToUploadPrizes[generatedRewardId]['amount'] = rewardVars.amount || "0";
            totalAmount+=(parseInt(rewardVars.amount) || 0);
            readyToUploadPrizes[generatedRewardId]['codes'] = rewardVars.codes || false;
            readyToUploadPrizes[generatedRewardId]['allElsePrize'] = rewardVars.allElsePrize || false;
            readyToUploadPrizes[generatedRewardId]['codesArray'] = rewardVars.codesArray || [];
            readyToUploadPrizes[generatedRewardId]['linksArray'] = rewardVars.linksArray || [];
            readyToUploadPrizes[generatedRewardId]['pinsArray'] = rewardVars.pinsArray || [];
            readyToUploadPrizes[generatedRewardId]['used'] = 0;
          }
          readyToUploadPrizes["totalRewards"] = totalAmount;
          readyToUploadPrizes["totalRewardsUsed"] = 0;
          readyToUploadPrizes["randomPrizeOrder"] = this.state["randomOrder" + i.toString()] || false;
          readyToUploadPrizes["answerLevel"] = i;
          rewardList.push(readyToUploadPrizes);
        }
        messaging_array.push(tiermessaging)
      }
      if(rewardList.length === 0 && !this.state.noPrizes){
        swal({
          title: "Hold On!",
          text: 'You have no rewards added to the game! You need at least 1',
          type: 'warning',
          confirmButtonText: 'Ok'
        })
        return;
      }
      createGameObject.questions = itemsAdded;
      createGameObject.status = 0;
      createGameObject.rewards = rewardList;
      createGameObject.gameName = gameName;
      createGameObject.active = false;
      createGameObject.tierMessaging = messaging_array;
      createGameObject['scheduleInfo'] = {};
      createGameObject['scheduleInfo']['performAt'] = inputtedDateSeconds;
      createGameObject['scheduleInfo']['endAt'] = inputtedEndDateSeconds;
      createGameObject['scheduleInfo']['status'] = "scheduled";
      let shouldReplaceCurrentGame  = true
      const currentGame = this.state.currentGame || {};
      if(currentGame.gameName){
        shouldReplaceCurrentGame = false;
      }

      createGameObject.timeStamp = Date.now()
      createGameObject.id = gameId;
      const vm = this;
      if(shouldReplaceCurrentGame){
        const onSaveAndClearSuccess = await this.saveAndClearGame(createGameObject, createGameObject.id);
        this.setState({loading: false, modal: false, editingGame: false})
        if(!onSaveAndClearSuccess){
          swal({
            title: "Hold On!",
            text: 'Failed to clear out old game, please try again',
            type: 'warning',
            confirmButtonText: 'Ok'
          })
        } else {
          this.setState({loading: false})
        }
      } else if(createGameObject.id) {
        this.setState({
          loading: true
        })
        base.post('futureGamesList/'+ createGameObject.id, {
          data: createGameObject,
          then(err){
            if(!err){
              vm.setState({
                modal: false,
                editingGame: false
              })
            }
            vm.setState({
              loading: false
            })
          }
        })
      }
    }

    async saveAndClearGame(futureGame, futureGameId){
      let url = `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api/saveAndClearGame`;
      if(process.env.NODE_ENV === "development"){
        url = `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1/api/saveAndClearGame`;
      }
      const bearerToken = await this.props.currentUser.getIdToken();
      const bearerTokenString = "Bearer " + bearerToken;
      this.setState({loading: true});
      let fetchObject = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': bearerTokenString
        },
        body: JSON.stringify({futureGame: futureGame, futureGameKey: futureGameId})
      }
      let response;
      try{
        response = await fetch(url, fetchObject);
        return response && response.ok;
      } catch (e) {
        console.log("ERROR: ", e);
        return false;
      }
    }

    async makeFutureGameCurrent(gameToSetCurrent){
      let url = `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api/saveAndClearGame`;
      if(process.env.NODE_ENV === "development"){
        url = `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1/api/saveAndClearGame`;
      }
      const bearerToken = await this.props.currentUser.getIdToken();
      const bearerTokenString = "Bearer " + bearerToken;
      this.setState({loading: true});
      let fetchObject = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': bearerTokenString
        },
        body: JSON.stringify({futureGame: gameToSetCurrent, futureGameKey: gameToSetCurrent.id})
      }
      let response;
      try{
        response = await fetch(url, fetchObject);
      } catch (e) {
        this.setState({loading: false});
        console.log("ERROR: ", e);
        return false;
      }
      const responseJson = await Promise.resolve(response.json());
      if(responseJson.error){
        this.setState({loading: false});
        swal({
          title: "Oh No!",
          text: "Something went wrong, please try again!",
          type: 'warning',
          confirmButtonText: 'Ok'
        })
        return;
      }
      const futureGameList = await this.getFutureGames();
      this.setState({
        futureGamesList: futureGameList,
        loading:false
      })
      this.setGameToWatch(gameToSetCurrent.id);
      swal({
        title: 'Game made current!',
        type: 'success',
        toast: true,
        position: 'top-end',
        showConfirmButton: true,
        timer: 10000
      })
    }

    async removeGameFromFutureList(gameToRemoveId){
      var futureGameList = this.state.futureGamesList;
      for(var gameIndex in futureGameList){
        var futureGame = futureGameList[gameIndex];
        if(futureGame.id === gameToRemoveId){
          futureGameList.splice(gameIndex, 1)
          if(gameToRemoveId){
            base.remove('futureGamesList/'+gameToRemoveId)
          }
        }
      }
      this.setState({
        futureGamesList: futureGameList
      })
    }

    detectHowManyCodesEntered(codesArray, areLinks){
      if(!codesArray){
        return [];
      }
      codesArray = codesArray.trim();
      const splitOnLineBreaks = codesArray.split("\n");
      let splitOnWhiteSpace = codesArray.split(/\s+/);
      let splitOnCommas = codesArray.split(",");
      let splitArray = splitOnLineBreaks;
      if(splitOnWhiteSpace.length === splitOnCommas.length){
        splitOnWhiteSpace = codesArray.replace(/,/g, '').split(/\s+/);
        splitOnCommas = codesArray.replace(/\s/g,'').split(",");
      }
      if(splitArray.length < splitOnWhiteSpace.length){
        splitArray = splitOnWhiteSpace
      }
      if(splitArray.length < splitOnCommas.length){
        splitArray = splitOnCommas
      }
      if(areLinks){
        for(const linkIndex in splitArray){
          const link = splitArray[linkIndex];
          if(!validUrl(link)){
            return {message:"Invalid Url", inValidUrl: link};
          }
        }
      }
      return splitArray
    }

    startScoreBoardVideo(){
      const currentGame = this.state.currentGame || {};
      const tenantVariables = this.state.tenantVariables;
      currentGame.status = 1;
      let countDownTimeToAdd = (parseInt(tenantVariables.timeToDeblur || 0) * currentGame.questions.length * 1000 + 2 * currentGame.questions.length) || 0;
      this.setState({
        currentGame: currentGame,
        timeModal: true,
        amountToAddToCountDown: countDownTimeToAdd
      })
      swal({
        title: 'Started Successfully',
        type: 'success',
        toast: true,
        position: 'top-end',
        showConfirmButton: true,
        timer: 10000
      })
    }

    cancelCountDown(){
      const currentGame = this.state.currentGame;
      currentGame.status = 0;

      this.setState({
        currentGame: currentGame,
        timeModal: false
      })
    }

    startGame(){
      let currentGame = this.state.currentGame;
      if(currentGame && currentGame.timeStamp){
        currentGame.active = true
        currentGame.timeStamp = Date.now()
        this.setState({
          currentGame: currentGame
        })
      }
    }

    stopGame(){
      var currentGame = this.state.currentGame;
      if(currentGame && currentGame.timeStamp){
        currentGame.active = false
        this.setState({
          currentGame
        })
      }
    }

    pauseRace() {
      let currentGame = this.state.currentGame;
      currentGame.status = 2;
      this.setState({currentGame})
      swal({
          title: 'Paused Successfully',
          type: 'success',
          toast: true,
          position: 'top-end',
          showConfirmButton: true,
          timer: 10000
        })
    }

    resetRace(){
      const currentGame = this.state.currentGame;
      swal({
          title: 'STOP!',
          text: 'Are you sure you want to do this?  This will reset peoples picks!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'YES',
        }).then(async (result)=>{
          if(result.value){
            currentGame.status = 0
            currentGame.sentEmail = false
            currentGame.active = false;
            for(let rewardLevelIndex in currentGame.rewards) {
              const rewardLevel = currentGame.rewards[rewardLevelIndex];
              rewardLevel.totalRewardsUsed = 0;
              for(let rewardLevelObjectParameter in rewardLevel){
                const parameter = rewardLevel[rewardLevelObjectParameter];
                if(typeof parameter === "object"){
                  parameter.used = 0
                }
              }
            }
            this.setState({
              currentGame,
              currentUserAnswersState: []
            })
            await base.remove("prizeWon");
            await base.remove("userAnswers");
            // Clear the public leaderboard too — the updateLeaderboard trigger skips deletes,
            // so nulling userAnswers alone would leave a stale board showing the old scores.
            await base.remove("scoreboardData");
            base.post(`emailsSent`, {
              data: null,
              then(err){
                if(!err){
                  console.log("reset emails sent")
                }
              }
            })
            base.post(`emailsToSend`, {
              data: null,
              then(err){
                if(!err){
                  console.log("reset emails to send")
                }
              }
            })
            swal({
              title: 'Reset Successful',
              type: 'success',
              toast: true,
              position: 'top-end',
              showConfirmButton: true,
              timer: 10000
            })
          }
      })
    }

    handleChange (evt) {
      const target = evt.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      this.setState({ [evt.target.name]: value });
    }

    toggle() {
      this.setState({
        modal: !this.state.modal,
        wizardLocation: "first",
        editingGame: false
      });
    }

    timeModalToggle(){
      this.setState({
        timeModal: !this.state.timeModal
      })
    }

    navButtonClicked(direction){
      const steps = ['first', 'second', 'third', 'fourth'];
      const currentIndex = steps.indexOf(this.state.wizardLocation);
      let nextIndex;
      if(direction === 'prev'){
        nextIndex = Math.max(0, currentIndex - 1);
      } else {
        nextIndex = Math.min(steps.length - 1, currentIndex + 1);
      }
      const nextStep = steps[nextIndex];
      const otherSteps = steps.filter(s => s !== nextStep);
      this.setState({ wizardLocation: nextStep });
      this.toggleWizardLocation(nextStep, ...otherSteps);
    }

    toggleWizardLocation(tabClicked, ...otherTabs){
      this.setState({
        wizardLocation: tabClicked
      })
      document.getElementById(tabClicked).classList.add('active');
      document.getElementById(tabClicked).classList.add('show');
      document.getElementById(tabClicked+'1').classList.add('active');
      document.getElementById(tabClicked+'1').classList.add('show');
      otherTabs.forEach(tab => {
        document.getElementById(tab).classList.remove('active');
        document.getElementById(tab).classList.remove('show');
        document.getElementById(tab+'1').classList.remove('active');
        document.getElementById(tab+'1').classList.remove('show');
      });
    }

    async switchStatsPrizes(buttonClicked){
      if(buttonClicked === "showStats"){
        document.getElementById('showPrizes').classList.remove('active');
        document.getElementById('showGames').classList.remove('active');
        document.getElementById('showStats').classList.add('active');
        this.setState({
          showStats:true,
          showPrizes:false,
          showGames:false
        })
      }else if(buttonClicked === "showPrizes"){
        document.getElementById('showPrizes').classList.add('active');
        document.getElementById('showStats').classList.remove('active');
        document.getElementById('showGames').classList.remove('active');
        this.setState({
          loading: true
        })
        const organizeUserAnswers = await sortPlayersForAdmin(null, null, appDatabasePrimaryFunctions, this.state.currentGame, process.env.REACT_APP_IS_MLB_TEAM === "true");
        this.setState({
          showStats:false,
          showPrizes:true,
          showGames:false,
          loading: false,
          currentUserAnswersState: organizeUserAnswers[0],
          showLinkColumn: organizeUserAnswers[1]
        })
      } else if(buttonClicked === "showGames"){
        document.getElementById('showPrizes').classList.remove('active');
        document.getElementById('showGames').classList.add('active');
        document.getElementById('showStats').classList.remove('active');
        const futureGameList = await this.getFutureGames();
        this.setState({
          showStats:false,
          showPrizes:false,
          showGames:true,
          futureGamesList: futureGameList
        })
      }
    }

    removeFromToAddArray(index, name){
      let removeArray = this.state[name];
      removeArray.splice(index, 1)
      this.setState({
        [name]: removeArray
      })
    }

    addRevealToLocalArray(){
      const itemsAddedArray = this.state.itemsAdded;
      const questionsList = this.state.questionsList;
      const revealKeys = []
      for(const revealIndex in itemsAddedArray){
        revealKeys.push(itemsAddedArray[revealIndex].key)
      }
      if(revealKeys.indexOf(this.state.select) !== -1){
        swal({
            title: `Question Already In Game!`,
            text: `This game already includes this question. Try adding another question.`,
            type: 'warning',
            confirmButtonText: 'Ok'
          })
        return;
      }
      let reveal = {};
      for(const revealIndex in questionsList){
        if(questionsList[revealIndex].key === this.state.select){
            reveal = questionsList[revealIndex]
            reveal.id = this.state.select
        }
      }
      if(reveal.id){
        reveal.status = 0
        reveal.progress = 0

         itemsAddedArray.push(reveal)
         this.setState({
           itemsAdded: itemsAddedArray
         })
      } else {
        swal({
            title: "Nothing Selected!",
            text: "Make sure to select an option before clicking 'Add'",
            type: 'warning',
            confirmButtonText: 'Ok'
          })
      }
    }

    async getFutureGames(numberOfResults = 10){
      return await base.fetch('futureGamesList', {
        context: this,
        asArray: true,
        queries: {
          orderByChild: 'scheduleInfo/performAt'
        },
        then(data){
          return data
        }
      })
    }

    saveReward (evt) {
      this.setState({ rewardToAdd: evt.target.value });
    }

    addRewardToLocalArray(index){
      const rewardAmount = this.state['rewardAmount' + index.toString()];
      let allElsePrize = this.state['allElsePrize' + index.toString()];
      if(index === 0){
        allElsePrize = true
      }
      const rewardId = this.state['ticket_select'+index.toString()];
      const codes = this.state['codes' + index.toString()];
      const links = this.state['links' + index.toString()];
      let codesArray = this.state['codesArray' + index.toString()] || '';
      let linksArray = this.state['linksArray' + index.toString()] || '';
      let pinsArray = this.state['pinsArray' + index.toString()] || '';
      codesArray = codesArray.replace(/\n/g, " ");
      linksArray = linksArray.replace(/\n/g, " ");
      pinsArray = pinsArray.replace(/\n/g, " ");
      let totalCodes = [];
      let totalLinks = [];
      let totalPins = [];
      if(codesArray.trim() === "" && codes && !allElsePrize){
        swal({
          title: 'Hold on!',
          text: 'Must enter codes or uncheck codes box!',
          type: 'warning',
          confirmButtonText: 'Ok'
        })
        return;
      } else if (codes && !allElsePrize){
        totalCodes = this.detectHowManyCodesEntered(codesArray);
        totalPins = this.detectHowManyCodesEntered(pinsArray);
        if(totalCodes.length !== parseInt(rewardAmount,10)){
          swal({
            title: 'Codes not equal!',
            text: "# of codes must equal number of rewards created. In this case: " +  totalCodes.length + " does not equal " + rewardAmount,
            type: 'warning',
            confirmButtonText: 'Ok'
          })
          return;
        } else if(totalPins.length !== 0 && totalPins.length !== parseInt(rewardAmount,10)){
          swal({
            title: 'Pins not equal!',
            text: "# of pins must equal number of rewards created. In this case: " +  totalPins.length + " does not equal " + rewardAmount,
            type: 'warning',
            confirmButtonText: 'Ok'
          })
          return;
        }
      }

      if(linksArray.trim() === "" && links && !allElsePrize){
        swal({
          title: 'Hold on!',
          text: 'Must enter links or uncheck links box!',
          type: 'warning',
          confirmButtonText: 'Ok'
        })
        return;
      } else if (links && !allElsePrize){
        totalLinks = this.detectHowManyCodesEntered(linksArray, true);
        if(totalLinks.inValidUrl){
          swal({
            title: 'Invalid URL Detected!',
            text: "Links must be valid urls. In this case: " +  totalLinks.inValidUrl + " is not valid",
            type: 'warning',
            confirmButtonText: 'Ok'
          })
          return;
        }
        if(totalLinks.length !== parseInt(rewardAmount,10)){
          swal({
            title: 'Codes not equal!',
            text: "# of links must equal number of rewards created. In this case: " +  totalLinks.length + " does not equal " + rewardAmount,
            type: 'warning',
            confirmButtonText: 'Ok'
          })
          return;
        }
      }

      if(!rewardId){
        swal({
          title: 'Missing field!',
          text: "Missing reward.  Can't add a reward to a game without selecting a reward",
          type: 'warning',
          confirmButtonText: 'Ok'
        })
        return;
      }

      if(!allElsePrize && (!rewardAmount || rewardAmount < 1 || rewardId.length < 1)){
        swal({
          title: 'Missing Amount',
          text: "Missing reward or amount of reward.  Can't add a reward to a game without an amount or selecting a reward",
          type: 'warning',
          confirmButtonText: 'Ok'
        })
        return;
      }
      const rewardToAddObject = {};
      for(let ticket in this.state.ticketList){
        if(this.state.ticketList[ticket].key === rewardId){
          rewardToAddObject.reward = this.state.ticketList[ticket];
          rewardToAddObject.allElsePrize = allElsePrize;
          rewardToAddObject.amount = allElsePrize ? null : rewardAmount;
          rewardToAddObject.codes = allElsePrize ? false : codes;
          rewardToAddObject.links = allElsePrize ? false : links;
          rewardToAddObject.codesArray = allElsePrize ? null : totalCodes;
          rewardToAddObject.linksArray = allElsePrize ? null : totalLinks;
          rewardToAddObject.pinsArray = allElsePrize ? null : totalPins;
        }
      }
      let array = this.state['rewardsAdded'+index.toString()] || [];
      let rewardsAddedIds = [];
      for(let prize in array){
        if(array[prize].allElsePrize && rewardToAddObject.allElsePrize){
          swal({
            title: 'Hold On!',
            text: "Cannot add two All Else Prizes to the same tier",
            type: 'warning',
            confirmButtonText: 'Ok'
          })
          return
        }
        rewardsAddedIds.push(array[prize].reward.key)
      }
      if(rewardsAddedIds.indexOf(rewardId) === -1){
        array = array.concat(rewardToAddObject)
        this.setState({
          ['rewardsAdded'+index.toString()]: array,
          convertToQrCode: false,
          codes: false,
          links: false
        })
      } else {
        swal({
          title: 'Prize already added!',
          text: "You have already added this prize",
          type: 'warning',
          confirmButtonText: 'Ok'
        })
      }
    }

    viewFutureGame(game) {
        this.setState({
            viewFutureGameModal: true,
            viewingFutureGame: game
        });
    }

    closeViewFutureGameModal() {
        this.setState({
            viewFutureGameModal: false,
            viewingFutureGame: null,
            expandedRewardCodes: {}
        });
    }

    toggleRewardCodes(rewardKey) {
        this.setState(prevState => ({
            expandedRewardCodes: {
                ...prevState.expandedRewardCodes,
                [rewardKey]: !prevState.expandedRewardCodes[rewardKey]
            }
        }));
    }

    render() {
      const isMlbApp =  process.env.REACT_APP_IS_MLB_TEAM === "true";
      let selectedGame = this.state.currentGame || {};
      let selectedGameRewards = [];
      let selectedGameQuestions = [];
      const futureGamesList = this.state.futureGamesList || [];
      const userAnswerCount = this.state.userAnswerCount || 0;
      const tenantVariables = this.state.tenantVariables || {};
      let questionsAddedLength = [];
      for (let i = -1; i < this.state.itemsAdded.length; i++) {
        questionsAddedLength.push(i);
      }
      let gameActive;
      let startTimeFirstPart = null;
      let startTimeSecondPart = null;
      let endTimeSecondPart = null;
      let endTimeFirstPart = null;
      let showTime = false;
      let currentUserAnswersState = this.state.currentUserAnswersState || [];
      let buttonText = "Scoreboard Run"
      if(selectedGame && selectedGame.gameName){
        selectedGameQuestions = selectedGame.questions || [];
        gameActive = selectedGame.active;
        selectedGameRewards = selectedGame.rewards || [];
        if(selectedGameRewards.length === 0 || tenantVariables.doNotCollectEmail){
          buttonText = "Game Ended"
        }
        if(selectedGame.scheduleInfo){
          const performAt = selectedGame.scheduleInfo.performAt;
          startTimeFirstPart = new Date(performAt).toLocaleDateString();
          startTimeSecondPart = new Date(performAt).toLocaleTimeString();
          if(selectedGame.scheduleInfo.endAt){
            endTimeFirstPart = new Date(selectedGame.scheduleInfo.endAt).toLocaleDateString();
            endTimeSecondPart = new Date(selectedGame.scheduleInfo.endAt).toLocaleTimeString();
          }
          if(performAt > Date.now()){
            showTime = true;
          }
        }
      } else {
        selectedGame = null;
        gameActive = false;
      }
      const vm = this;
      return (
        <div className="admin-wrapper">
          <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
          <SideMenu/>
          <TopMenu/>
          <div className="admin-main-panel">
            <div className="container" style={{padding:'20px', backgroundColor:'#e3eaef'}}>
              <div className="row align-items-center">
                <div className="col-auto">
                  <div className="card" style={{backgroundColor:'#00c78c', width:'100%', textAlign: 'center', height:'50px', display: gameActive ? '' : 'none', paddingLeft: 20, paddingRight: 20}}>
                    <p style={{lineHeight:'50px'}}>Game Is Active</p>
                  </div>
                  <div className="card" style={{backgroundColor:'#fe3b4b', width:'100%', textAlign: 'center', height:'50px', display: gameActive ? 'none' : '', paddingLeft: 20, paddingRight: 20}}>
                    <p style={{lineHeight:'50px'}}>Game is Inactive</p>
                  </div>
                </div>
                <div className="col-auto">
                  <button onClick={() =>  this.startScoreBoardVideo()} className="btn btn-primary btn-lg start-game-button" style={{display: selectedGame && selectedGame.status === 0 ? '' : 'none', float:'left', height:'52px'}}>
                    Run Scoreboard
                  </button>
                  {/*<div className="card" style={{backgroundColor:'#fe3b4b', width:'100%', textAlign: 'center', height:'50px', display: selectedGame && selectedGame.status === 0 ? '' : 'none', float:'left'}}>*/}
                  {/*  <p style={{lineHeight:'50px'}}>Running...</p>*/}
                  {/*</div>*/}
                  <div className="card" style={{backgroundColor:'#fe3b4b', width:'100%', textAlign: 'center', height:'50px', display: selectedGame && selectedGame.status === 1 ? '' : 'none', float:'left'}}>
                    <p style={{lineHeight:'50px'}}>{buttonText}</p>
                  </div>
                </div>
                <div className={classNames('col-auto text-center text-dark', { 'd-none': !gameActive })}>
                  <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="advanceSettings"
                        name="advanceSettings"
                        checked={this.state.advanceSettings}
                        onChange={this.handleChange}
                    />
                    <label className="form-check-label" htmlFor="advanceSettings">
                      Advanced
                    </label>
                  </div>
                </div>
                {/*<center className="col-md-1" style={{display: gameActive ? '' : 'none', color:'black'}}>*/}
                {/*  Advanced<input id="advanceSettings" name="advanceSettings" type="checkbox" checked={this.state.advanceSettings} onChange={this.handleChange} />*/}
                {/*</center>*/}
                <div className="col-auto">
                  <button onClick={() => this.startGame()} className="btn btn-primary btn-lg start-game-button" style={{display: gameActive ? 'none' : '', float:'left', height:'52px'}}>Start Game</button>
                  <button onClick={() => this.stopGame()} className="btn btn-primary btn-lg end-game-button" style={{display: gameActive && this.state.advanceSettings ? '' : 'none', float:'left', height:'52px' }}>Stop Game</button>
                </div>
                <div className="col-auto ms-auto justify-content-end">
                  <a className="btn btn-outline-danger btn-sm" onClick={() => this.resetRace()} style={{display: selectedGame ? '' : 'none', marginTop:'7px', float:'right'}}>Reset Game</a>
                  <button onClick={() => this.toggle()} className="btn btn-primary btn-lg create-game-button" style={{float:'right', marginRight:'5px'}}>New Game</button>
                </div>
              </div>
            </div>
            <div style={{display: !selectedGame ? 'none': 'block'}}>
              <div className="container">
                <div className="row">
                  <div className="col-md-2" style={{color: "black", border: "solid 1px #d3d3d3", marginLeft:10, marginTop: 10, marginBottom:10, borderRadius: 5, display: !showTime && "none"}}>
                    <div className="row">
                      <div className="col-md-6">
                        <u style={{color:"#353839"}}>Starts</u>
                        <br/>
                        <span style={{fontSize:18}}>{startTimeFirstPart || "No Start Time"}<br/>{startTimeSecondPart}</span>
                      </div>
                      <div className="col-md-6">
                        <u style={{color:"#353839"}}>Ends</u>
                        <br/>
                        <span style={{fontSize:18}}>{endTimeFirstPart || "No End Time"}<br/>{endTimeSecondPart}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2" style={{color: "black", border: "solid 1px #d3d3d3", marginLeft: 10, marginTop:10, marginBottom:10, borderRadius: 5}}>
                    <div className="row">
                      <div className="col-md-12" style={{textAlign:'center'}}>
                        <span style={{fontSize:12}}>Current Game Answers</span>
                        <footer className="value-text">{userAnswerCount}</footer>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <div className="card-body">
                <ul className="nav nav-tabs nav-justified nav-bordered mb-3">
                    <li className="nav-item" onClick={()=> this.switchStatsPrizes("showStats")}>
                        <a href="#" data-toggle="tab" aria-expanded="false" className="nav-link active" id="showStats" style={{backgroundColor:'#fafbfe'}}>
                            <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                            <span className="d-none d-lg-block">Game Details</span>
                        </a>
                    </li>
                    <li className="nav-item" onClick={()=> this.switchStatsPrizes("showPrizes")}>
                        <a href="#" data-toggle="tab" aria-expanded="true" className="nav-link" id="showPrizes" style={{backgroundColor:'#fafbfe'}}>
                            <i className="mdi mdi-account-circle d-lg-none d-block mr-1"/>
                            <span className="d-none d-lg-block">Results</span>
                        </a>
                    </li>
                    <li className="nav-item" onClick={()=> this.switchStatsPrizes("showGames")}>
                        <a href="#" data-toggle="tab" aria-expanded="true" className="nav-link" id="showGames" style={{backgroundColor:'#fafbfe'}}>
                            <i className="mdi mdi-account-circle d-lg-none d-block mr-1"/>
                            <span className="d-none d-lg-block">Future Games</span>
                        </a>
                    </li>
                </ul>
                <div style={{display: this.state.showPrizes ? 'block' : 'none'}}>
                  <div className="export-button-styles btn btn-primary btn-lg download-button" style={{marginBottom:10, marginLeft: 10}} onClick={()=>this.downloadUsers()}>
                    <span className="fa fa-arrow-circle-down"/> Download Participants
                  </div>
                  <table className="table table-striped" style={{color:'black'}}>
                    <tbody>
                      <tr>
                        <th>{tenantVariables.doNotCollectEmail || isMlbApp ? "UID" : "Email"}</th>
                        <th>Correct</th>
                        <th>Time Stamp</th>
                        <th>Place</th>
                        <th>Reward</th>
                        <th>Code</th>
                      </tr>
                      {
                        currentUserAnswersState.map(function(item,i){
                            const timeStamp = convertTimeStampToHumanReadable(item.timeStamp);
                            return <tr key={i}>
                              <td style={{fontFamily:'Open Sans'}}>{tenantVariables.doNotCollectEmail || isMlbApp ? item.uid : item.email}</td>
                              <td style={{fontFamily:'Open Sans' }}>{item.correctAnswers}</td>
                              <td style={{fontFamily:'Open Sans' }}>{timeStamp}</td>
                              <td style={{fontFamily:'Open Sans' }}>{i + 1}</td>
                              <td style={{fontFamily:'Open Sans' }}>{item.rewardSent || "NONE"}</td>
                              <td style={{fontFamily:'Open Sans' }}>{item.code || "NONE"}</td>
                            </tr>
                        }, this)
                      }
                    </tbody>
                  </table>
                </div>
                <div style={{display: this.state.showStats ? 'block' : 'none'}}>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6" style={{textAlign:"center"}}>
                        <h4 style={{color:'black'}}>Rewards</h4>
                        {selectedGameRewards && selectedGameRewards.length > 0 && valueDoesExist(selectedGameRewards[0].answerLevel) ?
                            <Accordion style={{margin:10}}>
                              {
                                selectedGameRewards.sort(function(a,b){return a.answerLevel - b.answerLevel}).map(function (item, i) {
                                  const rewards = [];
                                  let allElseReward;
                                  for(const rewardObjetIndex in item){
                                    const reward = item[rewardObjetIndex];
                                    if(typeof reward === "object"){
                                      if(reward.allElsePrize){
                                        allElseReward = reward;
                                      } else {
                                        rewards.push(reward);
                                      }
                                    }
                                  }
                                  return <AccordionItem className="blackBackgroundColor" bodyClassName="changeBackgroundColor" key={i} title={`${(item.answerLevel).toString()} correct`} expanded={i === 0}>
                                    {
                                      rewards.map(function(reward, index){
                                        return <div key={index} style={{color:"black"}}>
                                          <span>{reward.amount}, {reward.rewardName}</span>
                                        </div>
                                      })
                                    }
                                    {allElseReward &&
                                    <div style={{color:"black"}}>
                                      {rewards.length > 0 &&
                                      <br/>
                                      }
                                      <span>
                                        <span style={{color:"grey", fontWeight: 100, fontFamily: "sans-serif"}}>
                                          Everyone Else Wins
                                        </span>
                                        {allElseReward.rewardName}
                                      </span>
                                    </div>
                                    }
                                  </AccordionItem>
                                })
                              }
                            </Accordion>
                            :
                            <>
                              {selectedGameRewards && selectedGameRewards.length > 0 ?
                                  <>
                                    {selectedGameRewards.map(function(reward, index){
                                      return <div style={{color:'black'}}>
                                        {reward.rewardName}
                                      </div>
                                    })}
                                  </>
                                  :
                                  <span style={{color:'black'}}>
                                    No Prizes Added
                                  </span>
                              }
                            </>
                        }
                      </div>
                      <div className="col-md-6 justify-content-center" style={{textAlign:"center"}}>
                        <h4 style={{color:'black'}}>Details</h4>
                        {selectedGame && selectedGame.gameName &&
                          <div style={{textAlign:'left', color:'black'}}>
                            Game Name: {selectedGame.gameName}
                            {selectedGame.scheduleInfo &&
                              <p>Scheduled for: {convertTimeStampToHumanReadable(selectedGame.scheduleInfo.performAt)}</p>
                            }
                            <Carousel style={{backgroundColor:'white'}} showArrows={true} showStatus={false} showIndicators={false} showThumbs={false} selectedItem={this.state.selectedItem} onChange={(e) => {
                              this.setState({
                                selectedItem: e,
                              });
                            }}>
                              {
                                selectedGameQuestions.map(function(item, i){
                                  return <div style={{backgroundColor: "#FAFBFE", padding:10}} key={i}>
                                    <p style={{color:'black'}}>{i+1}/{selectedGameQuestions.length.toString()}</p>
                                    <p style={{color:'black'}}>{item.questionText}</p>
                                    <ol style={{textAlign:'left'}}>
                                      {
                                        item.answers.sort((a, b) => a.order - b.order).map(function(answer, i) {
                                          if(answer.correct){
                                            return <li key={i} style={{color:'green'}}>
                                                <img width={"auto"} height={"auto"} style={{maxHeight: 100, maxWidth: 100}} src={answer.answerImage} alt=""/>
                                                <div style={{position:"relative", display: "inline-block", marginLeft: 5}}>
                                                  <span style={{position:"absolute", left:0,right:0,top:40,bottom:0,margin:"auto"}}>
                                                    Correct
                                                  </span>
                                                </div>
                                            </li>
                                          } else {
                                            return <li key={i} style={{color:'black'}}>
                                                <img width={"auto"} height={"auto"} style={{maxHeight: 100, maxWidth: 100}} src={answer.answerImage} alt=""/>
                                              </li>
                                          }
                                        })
                                      }
                                    </ol>
                                  </div>
                                })
                              }
                            </Carousel>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{display: this.state.showGames ? 'block' : 'none'}}>
                  <p style={{color:'black', marginLeft:20, fontSize:20, marginTop:20}}>Future Games</p>
                  <table className="table table-striped" style={{color:'black'}}>
                    <tbody>
                      <tr>
                        <th>Name</th>
                        <th>Date</th>
                        <th>Rewards</th>
                        <th>Questions</th>
                        <th>Make Current Game</th>
                        <th>Delete Game</th>
                        <th>View</th>
                        <th>Edit</th>
                      </tr>
                      {
                        futureGamesList.map(function(item,i){
                            const dateTime = convertTimeStampToHumanReadable(item.scheduleInfo.performAt)
                            return <tr key={i}>
                              <td style={{fontFamily:'Open Sans'}}>{item.gameName}</td>
                              <td style={{fontFamily:'Open Sans' }}>{dateTime}</td>
                              <td style={{fontFamily:'Open Sans' }}>{item.rewards ? item.rewards.length : "None"}</td>
                              <td style={{fontFamily:'Open Sans' }}>{item.questions.length}</td>
                              <td style={{fontFamily:'Open Sans' }}><button className="btn btn-primary" onClick={()=>this.makeFutureGameCurrent(item)}>MAKE CURRENT</button></td>
                              <td style={{fontFamily:'Open Sans' }}><button className="btn btn-danger" onClick={()=>this.removeGameFromFutureList(item.id)}>DELETE</button></td>
                    <td style={{fontFamily:'Open Sans' }}><button className="btn btn-primary" onClick={()=>this.viewFutureGame(item)}>VIEW</button></td>
                    <td style={{fontFamily:'Open Sans' }}><button className="btn btn-primary" onClick={()=>this.editGame(item)}>EDIT</button></td>
                            </tr>
                        }, this)
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <Modal isOpen={this.state.modal} toggle={this.toggle} style={{width: '90%'}} id="myModal">
              <div className="card">
                <div className="card-body">
                  <h4 className="header-title mb-3"> {this.state.editingGame ? "Edit" : "Create"} Game</h4>
                  <div id="rootwizard">
                    <ul className="nav nav-pills bg-dark-light nav-justified mb-3">
                        <li className="nav-item" onClick={() => this.toggleWizardLocation('first', 'second', 'third', 'fourth')}>
                            <a href="#" className="nav-link rounded-0 pt-2 pb-2 active show" id="first1">
                                <span className="fa fa-pencil-square-o"/>
                                <span className="d-none d-sm-inline"> Game Details</span>
                            </a>
                        </li>

                        <li className="nav-item" onClick={() => this.toggleWizardLocation('second', 'first', 'third', 'fourth')}>
                            <a href="#" className="nav-link rounded-0 pt-2 pb-2" id="second1">
                                <span className="fa fa-question-circle"/>
                                <span className="d-none d-sm-inline"> Select Questions</span>
                            </a>
                        </li>

                        <li className="nav-item" onClick={() => this.toggleWizardLocation('third', 'first', 'second', 'fourth')}>
                            <a href="#" className="nav-link rounded-0 pt-2 pb-2" id="third1">
                                <span className="fa fa-trophy"/>
                                <span className="d-none d-sm-inline"> Add Prizes</span>
                            </a>
                        </li>
                        <li className="nav-item" onClick={() => this.toggleWizardLocation('fourth', 'first', 'second', 'third')}>
                            <a href="#" className="nav-link rounded-0 pt-2 pb-2" id="fourth1">
                                <span className="fa fa-sign-out"/>
                                <span className="d-none d-sm-inline"> Finish</span>
                            </a>
                        </li>
                    </ul>

                    <div className="tab-content mb-0 b-0" style={{fontFamily:'Roboto'}}>

                        <div className="tab-pane active show" id="first">
                            <form id="accountForm" method="post" action="#" className="form-horizontal">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group row mb-3">
                                          <label className="col-md-3 col-form-label" htmlFor="gameName"> Game Name</label>
                                          <div className="col-sm-9">
                                              <input id="gameName" name="gameName" className="form-control" type="text" value={this.state.gameName} onChange={this.handleChange} placeholder="Example: 10/13 Game Dallas" />
                                          </div>
                                        </div>
                                        <div className="form-group row mb-3">
                                          <label className="col-md-3 col-form-label" htmlFor="schedule_game_time"> Game Start Time</label>
                                          <div className="col-md-9">
                                            <DatePicker showTimeInput dateFormat="Pp" selected={this.state.schedule_game_time} onChange={date => this.setState({schedule_game_time: date})}/>
                                          </div>
                                        </div>
                                        <div className="form-group row mb-3">
                                          <label className="col-md-3 col-form-label" htmlFor="schedule_game_time_end"> Game End Time</label>
                                          <div className="col-md-9">
                                            <DatePicker showTimeInput dateFormat="Pp" selected={this.state.schedule_game_time_end} onChange={date => this.setState({schedule_game_time_end: date})}/>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div className="tab-pane" id="second">
                            <div className="form-group row mb-3">
                              <label className="col-md-3 col-form-label" htmlFor="name3"> Select Questions</label>
                              <div className="col-md-9">
                                <select className="form-control" name="select" id="select" value={this.state.select} onChange={this.handleChange}>
                                  <option/>
                                  {
                                    this.state.questionsList.map(function(item,index){
                                      return(
                                        <option value={item.key} key={index}>{item.name}</option>
                                      )
                                    })
                                  }
                                </select>
                              </div>
                            </div>
                            <div className="form-group row mb-3" align="center">
                              <div className="col-md-12">
                                <button className="btn btn-primary btn-admin" onClick={()=>this.addRevealToLocalArray()}>Add</button>
                              </div>
                            </div>
                            <div className="form-group mb-3">
                                <ol>
                                  {
                                    this.state.itemsAdded.map(function(item,index){
                                      return(
                                        <li key={index} style={{margin:10}}> {item.name}
                                          <span style={{marginLeft:"40px"}}>
                                            <button className="btn btn-danger btn-admin" style={{marginLeft:"40px"}} onClick={()=>this.removeFromToAddArray(index, "itemsAdded")}><span className="fa fa-trash"/></button>
                                          </span>
                                        </li>
                                      )
                                    }, this)
                                  }
                                </ol>
                            </div>
                        </div>

                         <div className="tab-pane" id="third">
                           <div className="form-horizontal">
                             <div className="row">
                               <div className="col-12" style={{textAlign:'center'}}>
                                 <div className="form-check">
                                   <input style={{float: "none", marginRight:3}} value={this.state.noPrizes} className="form-check-input" id="noPrizes" name="noPrizes" type="checkbox" checked={this.state.noPrizes} onChange={this.handleChange} />
                                   <label className="form-check-label" htmlFor="codes">No Prizes</label>
                                 </div>
                               </div>
                             </div>
                             <div className="row">
                               <div className="col-12">
                                 <Accordion style={{margin:10}}>
                                   {
                                     questionsAddedLength.map(function(item,index){
                                       let winningHeader = "You win!"
                                       let winningMessage = "Check your email for your prize!"
                                       let winningMissedHeader = "Nice Job!"
                                       let winningMissedMessage = "You got " + index.toString() + " correct! Unfortunately you didn't win a prize but try again soon!"
                                       if(index > 0){
                                         winningMessage = "You got " + index.toString() + " correct! Check your email for your prize!"
                                       }
                                       if(this.state['winningWinnerHeader' + index.toString()] != undefined){
                                         winningHeader = this.state['winningWinnerHeader' + index.toString()]
                                       } else if(tenantVariables.globalNoneCorrectPrizeHeader && tenantVariables.globalNoneCorrectPrizeHeader.length > 0 && index === 0) {
                                         winningHeader = this.detectUseOfIndex(tenantVariables.globalNoneCorrectPrizeHeader, index)
                                       } else if (tenantVariables.globalPrizeWonHeader && tenantVariables.globalPrizeWonHeader.length > 0) {
                                         winningHeader = this.detectUseOfIndex(tenantVariables.globalPrizeWonHeader, index)
                                       }
                                       if(this.state['winningWinnerMessage' + index.toString()] != undefined){
                                         winningMessage = this.state['winningWinnerMessage' + index.toString()]
                                       } else if(tenantVariables.globalNoneCorrectPrizeBody && tenantVariables.globalNoneCorrectPrizeBody.length > 0 && index === 0) {
                                         winningMessage = this.detectUseOfIndex(tenantVariables.globalNoneCorrectPrizeBody, index)
                                       } else if (tenantVariables.globalPrizeWonBody && tenantVariables.globalPrizeWonBody.length > 0) {
                                         winningMessage = this.detectUseOfIndex(tenantVariables.globalPrizeWonBody, index)
                                       }
                                       if(this.state['winningMissedHeader' + index.toString()] != undefined){
                                         winningMissedHeader = this.state['winningMissedHeader' + index.toString()]
                                       } else if (tenantVariables.globalNoPrizeHeader && tenantVariables.globalNoPrizeHeader.length > 0) {
                                         winningMissedHeader = this.detectUseOfIndex(tenantVariables.globalNoPrizeHeader, index)
                                       }
                                       if(this.state['winningMissedMessage' + index.toString()] != undefined){
                                         winningMissedMessage = this.state['winningMissedMessage' + index.toString()]
                                       } else if (tenantVariables.globalNoPrizeBody && tenantVariables.globalNoPrizeBody.length > 0) {
                                         winningMissedMessage = this.detectUseOfIndex(tenantVariables.globalNoPrizeBody, index)
                                       }
                                       return(
                                           <AccordionItem key={index} className="if-number-correct-item" title={`If a fan answers ${(index).toString()} correct`} expanded={index === 0}>
                                             {!this.state.noPrizes &&
                                             <span>
                                                  <div className="form-group row mb-3">
                                                    <label className="col-md-3 col-form-label" htmlFor={`ticket_select${(index).toString()}`}> Select Prize</label>
                                                    <div className="col-md-6">
                                                      <select className="form-control" name={`ticket_select${(index).toString()}`} id={`ticket_select${(index).toString()}`} value={this.state['ticket_select' + index.toString()]} onChange={this.handleChange}>
                                                        <option/>
                                                        {
                                                          this.state.ticketList.map(function (item, index) {
                                                            return (
                                                                <option value={item.key}
                                                                        key={index}>{item.rewardName}</option>
                                                            )
                                                          })
                                                        }
                                                      </select>
                                                    </div>
                                                    <div className="col-md-3" style={{alignSelf:"center", textAlign: "right"}}>
                                                      <div className="form-check">
                                                        <input id={`allElsePrize${(index).toString()}`} className="form-check-input" name={`allElsePrize${(index).toString()}`} type="checkbox" checked={this.state['allElsePrize' + index.toString()] || index === 0} onChange={this.handleChange} />
                                                        <label className="form-check-label" htmlFor={`allElsePrize${(index).toString()}`}>All Else Prize</label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="form-group row mb-3" style={{display: index > 0 && !this.state['allElsePrize' + index.toString()] ? 'flex' : 'none', alignItems:'center'}}>
                                                    <label className="col-md-3 col-form-label" htmlFor={`rewardAmount${(index).toString()}`}> How Many Of This Reward To Give Out?</label>
                                                    <div className="col-md-4">
                                                      <input id={`rewardAmount${(index).toString()}`} name={`rewardAmount${(index).toString()}`} type="number" className="form-control" value={this.state['rewardAmount' + index.toString()]} onChange={this.handleChange} placeholder="5" />
                                                    </div>
                                                    <div className="form-check" style={{marginLeft: 5}}>
                                                      <input id={`codes${(index).toString()}`} className="form-check-input" name={`codes${(index).toString()}`} type="checkbox" checked={this.state['codes' + index.toString()]} onChange={this.handleChange} />
                                                      <label className="form-check-label" htmlFor={`codes${(index).toString()}`}>Add Codes</label>
                                                    </div>
                                                    {!isMlbApp &&
                                                        <div className="form-check" style={{marginLeft: 5}}>
                                                          <input id={`links${(index).toString()}`} className="form-check-input" name={`links${(index).toString()}`} type="checkbox" checked={this.state['links' + index.toString()]} onChange={this.handleChange} />
                                                          <label className="form-check-label" htmlFor={`links${(index).toString()}`}>Add Links</label>
                                                        </div>
                                                    }
                                                  </div>
                                                  <div className="form-group row mb-3" style={{display: this.state['codes' + index.toString()] && !this.state['allElsePrize' + index.toString()] ? 'flex' : 'none'}}>
                                                    <label htmlFor={`codesArray${(index).toString()}`} className="col-md-3 col-form-label">Enter Codes (code1,code2)</label>
                                                    <div className="col-md-9">
                                                      <textarea value={this.state['codesArray' + index.toString()]} className="form-control" name={`codesArray${(index).toString()}`} onChange={this.handleChange} placeholder="code1,code2,code3"/>
                                                    </div>
                                                  </div>
                                                  <div className="form-group row mb-3" style={{display: this.state['codes' + index.toString()] && !this.state['allElsePrize' + index.toString()] ? 'flex' : 'none'}}>
                                                    <label htmlFor={`pinsArray${(index).toString()}`} className="col-md-3 col-form-label">Enter Pins</label>
                                                    <div className="col-md-9">
                                                      <textarea value={this.state['pinsArray' + index.toString()]} className="form-control" name={`pinsArray${(index).toString()}`} onChange={this.handleChange} placeholder="pin1,pin2,pin3"/>
                                                    </div>
                                                  </div>
                                                  <div className="form-group row mb-3" style={{display: this.state['links' + index.toString()] && !this.state['allElsePrize' + index.toString()] ? 'flex' : 'none'}}>
                                                    <label htmlFor={`linksArray${(index).toString()}`} className="col-md-3 col-form-label">Enter links</label>
                                                    <div className="col-md-9">
                                                      <textarea value={this.state['linksArray' + index.toString()]} className="form-control" name={`linksArray${(index).toString()}`} onChange={this.handleChange} placeholder="https://myfirstlink.com, https://mysecondlink.com, https://mythirdlink.com"/>
                                                    </div>
                                                  </div>
                                                  <div className="form-group row mb-3" align="center">
                                                      <div className="col-md-12">
                                                          <button className="btn btn-primary btn-admin" onClick={()=>this.addRewardToLocalArray(index)}>Add Reward</button>
                                                      </div>
                                                  </div>
                                               {this.state['rewardsAdded'+index.toString()] && this.state['rewardsAdded'+index.toString()].length > 1 &&
                                               <div className="form-check" >
                                                 <input value={this.state['randomOrder'+index.toString()]} className="form-check-input" id={`randomOrder${(index).toString()}`} name={`randomOrder${(index).toString()}`} type="checkbox" checked={this.state['randomOrder' +index.toString()]} onChange={this.handleChange} />
                                                 <label className="form-check-label" htmlFor={`randomOrder${(index).toString()}`}>Give Out In Random Order</label>
                                               </div>
                                               }
                                               <div className="form-group mb-3">
                                                      <ol style={{listStylePosition: 'inside', textAlign:'left'}} className="offset-md-0 col-md-10">
                                                          {
                                                            this.state['rewardsAdded'+index.toString()] && this.state['rewardsAdded'+index.toString()].map(function(item,addedIndex){
                                                              let codesText = "No"
                                                              if(item.codes){
                                                                codesText = "Yes"
                                                              }
                                                              return(
                                                                  <div key={addedIndex} className="form-group">
                                                                    <li>) {item.amount || "All Else Prize"} - {item.reward.rewardName}{item.amount && "; Codes: "+codesText} <span style={{float:'right'}} className="fa fa-trash-o" onClick={()=>vm.removeFromToAddArray(addedIndex,'rewardsAdded'+index.toString())}/></li>
                                                                  </div>
                                                              )
                                                            })
                                                          }
                                                      </ol>
                                                  </div>
                                                </span>
                                             }
                                             <div className="form-check">
                                               <input className="form-check-input" name={`textEditChanges${(index).toString()}`} type="checkbox" checked={this.state['textEditChanges' + index.toString()]} onChange={this.handleChange} />
                                               <label className="form-check-label" htmlFor={`textEditChanges${(index).toString()}`}>Advanced Text Changes</label>
                                             </div>
                                             <div className="form-group row mb-3" style={{display: this.state['textEditChanges' + index.toString()] && !this.state.noPrizes ? 'flex' : 'none', alignItems: "center" }}>
                                               <label htmlFor={`winningWinnerHeader${(index).toString()}`} className="col-md-3 col-form-label">Prize Header</label>
                                               <div className="col-md-9">
                                                 <input value={winningHeader} className="form-control" name={`winningWinnerHeader${(index).toString()}`} type="text" onChange={this.handleChange}/>
                                               </div>
                                             </div>
                                             <div className="form-group row mb-3" style={{display: this.state['textEditChanges' + index.toString()] && !this.state.noPrizes ? 'flex' : 'none', alignItems: "center" }}>
                                               <label htmlFor={`winningWinnerMessage${(index).toString()}`} className="col-md-3 col-form-label">Prize Message</label>
                                               <div className="col-md-9">
                                                 <input value={winningMessage} className="form-control" name={`winningWinnerMessage${(index).toString()}`} type="text" onChange={this.handleChange}/>
                                               </div>
                                             </div>
                                             <div className="form-group row mb-3" style={{display: this.state['textEditChanges' + index.toString()] ? 'flex' : 'none', alignItems: "center" }}>
                                               <label htmlFor={`winningMissedHeader${(index).toString()}`} className="col-md-3 col-form-label">No Prize Header</label>
                                               <div className="col-md-9">
                                                 <input value={winningMissedHeader} className="form-control" name={`winningMissedHeader${(index).toString()}`} type="text" onChange={this.handleChange}/>
                                               </div>
                                             </div>
                                             <div className="form-group row mb-3" style={{display: this.state['textEditChanges' + index.toString()] ? 'flex' : 'none', alignItems: "center" }}>
                                               <label htmlFor={`winningMissedMessage${(index).toString()}`} className="col-md-3 col-form-label">No Prize Message</label>
                                               <div className="col-md-9">
                                                 <input value={winningMissedMessage} className="form-control" name={`winningMissedMessage${(index).toString()}`} type="text" onChange={this.handleChange}/>
                                               </div>
                                             </div>
                                           </AccordionItem>
                                       );
                                     }, this)
                                   }
                                 </Accordion>
                               </div>
                             </div>
                           </div>
                        </div>

                        <div className="tab-pane fade" id="fourth">
                            <form id="otherForm" method="post" action="#" className="form-horizontal"/>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="text-center">
                                            <h2 className="mt-0">
                                                <i className="mdi mdi-check-all"/>
                                            </h2>
                                            <h3 className="mt-0">Finish</h3>
                                            <div className="row form-group">
                                              <div className="col-md-12">
                                                <p>You are all set to {this.state.editingGame ? "edit" : "create"} a game!  Before clicking "{this.state.editingGame ? "Edit" : "Create"} Game" make sure all the settings are the way you want. Feel free to navigate back to edit anything you like!</p>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                        </div>

                        <ul className="list-inline wizard mb-0">
                            <li className="previous list-inline-item" style={{display: this.state.wizardLocation !== 'first' ? '' : 'none' }}><a href="#" className="btn btn-primary btn-lg previous-wizard-button" onClick={() => this.navButtonClicked('prev')}>Previous</a></li>
                            <li className="next list-inline-item float-end"><a href="#" className="btn btn-primary btn-lg next-wizard-button" onClick={() => this.navButtonClicked('next')} style={{display: this.state.wizardLocation !== 'fourth' ? '' : 'none' }}>Next</a></li>
                            <li className="next list-inline-item float-end"><a href="#" className="btn btn-primary btn-lg creategame-wizard-button" onClick={() => this.createGame()} style={{display: this.state.wizardLocation === 'fourth' ? '' : 'none' }}>{this.state.editingGame ? "Edit" : "Create"} Game</a></li>
                        </ul>

                      </div>
                    </div>
                </div>
              </div>
          </Modal>
          <Modal isOpen={this.state.timeModal} toggle={this.timeModalToggle} style={{width: '90%'}} id="myTimeModal">
            <div className="card">
              <center className="card-body">
                <h4 className="header-title mb-3"> Scoreboard Animating, Please Wait</h4>
                <Countdown
                    date={Date.now() + this.state.amountToAddToCountDown}
                    intervalDelay={0}
                    precision={0}
                    onComplete={() => this.setState({timeModal: false, amountToAddToCountDown:0})}
                    renderer={(props) => (
                        <div style={{fontSize: 30}}>
                          {props.total ? props.total/1000 :0}
                        </div>
                    )}
                />
                <div>
                  <p>DO NOT REFRESH OR QUIT THE BROWSER WHILE THE TIMER IS RUNNING</p>
                  <button className="btn btn-danger" onClick={() => this.cancelCountDown()}>CANCEL COUNTDOWN AND RESET</button>
                </div>
              </center>
            </div>
          </Modal>
                <Modal isOpen={this.state.viewFutureGameModal} toggle={() => this.closeViewFutureGameModal()} style={{width: '90%', maxWidth: '800px'}}>
                    <ModalHeader toggle={() => this.closeViewFutureGameModal()}>
                        View Scheduled Game
                    </ModalHeader>
                    <ModalBody style={{padding: '25px'}}>
                        {this.state.viewingFutureGame && (
                            <div style={{color: 'black', padding: '15px'}}>
                                <h4>{this.state.viewingFutureGame.gameName}</h4>
                                <hr/>

                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <strong>Start Time:</strong> {this.state.viewingFutureGame.scheduleInfo ? convertTimeStampToHumanReadable(this.state.viewingFutureGame.scheduleInfo.performAt) : 'N/A'}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>End Time:</strong> {this.state.viewingFutureGame.scheduleInfo ? convertTimeStampToHumanReadable(this.state.viewingFutureGame.scheduleInfo.endAt) : 'N/A'}
                                    </div>
                                </div>

                                <hr/>
                                <h5>Questions</h5>
                                {this.state.viewingFutureGame.questions && this.state.viewingFutureGame.questions.length > 0 ? (
                                    <ol>
                                        {this.state.viewingFutureGame.questions.map(function(question, qIndex) {
                                            return (
                                                <li key={qIndex} style={{marginBottom: 10}}>
                                                    <strong>{question.name}</strong>
                                                    {question.questionText && <span> — {question.questionText}</span>}
                                                </li>
                                            );
                                        })}
                                    </ol>
                                ) : (
                                    <p>No questions added</p>
                                )}

                                <hr/>
                                <h5>Prizes</h5>
                                {this.state.viewingFutureGame.rewards && this.state.viewingFutureGame.rewards.length > 0 ? (
                                    <div>
                                        {this.state.viewingFutureGame.rewards.map((tier, tierIndex) => {
                                            const rewards = [];
                                            for (const rewardKey in tier) {
                                                const reward = tier[rewardKey];
                                                if (typeof reward === 'object' && reward.rewardName) {
                                                    rewards.push({key: rewardKey, ...reward});
                                                }
                                            }
                                            return (
                                                <div key={tierIndex} className="mb-3 p-2" style={{border: '1px solid #dee2e6', borderRadius: '5px'}}>
                                                    <strong>{valueDoesExist(tier.answerLevel) ? `${tier.answerLevel} Correct` : `Tier ${tierIndex + 1}`}</strong>
                                                    <span className="ms-2 text-muted">(Total: {tier.totalRewards || 0})</span>
                                                    {rewards.map((reward, rIndex) => {
                                                        const hasCodes = reward.codes && reward.codesArray && reward.codesArray.length > 0;
                                                        const expandKey = `${tierIndex}-${reward.key}`;
                                                        const isExpanded = this.state.expandedRewardCodes[expandKey];
                                                        return (
                                                            <div key={rIndex} className="p-2 mt-2" style={{border: '1px solid #eee', borderRadius: '4px', backgroundColor: '#fafbfe'}}>
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div>
                                                                        <strong>{reward.rewardName}</strong>
                                                                        {reward.allElsePrize && <span className="badge bg-warning ms-2">All Else Prize</span>}
                                                                        {reward.isRedeemable && <span className="badge bg-info ms-2">Redeemable</span>}
                                                                        {hasCodes ? (
                                                                            <span
                                                                                className="badge bg-success ms-2"
                                                                                style={{cursor: 'pointer'}}
                                                                                onClick={() => this.toggleRewardCodes(expandKey)}
                                                                            >
                                                                                Codes ({reward.codesArray.length}) {isExpanded ? '▲' : '▼'}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge bg-secondary ms-2">No Codes</span>
                                                                        )}
                                                                    </div>
                                                                    {reward.amount && <span>Amount: {reward.amount}</span>}
                                                                </div>
                                                                {hasCodes && isExpanded && (
                                                                    <div className="mt-2 p-2" style={{backgroundColor: '#f8f9fa', borderRadius: '4px', maxHeight: '150px', overflowY: 'auto'}}>
                                                                        <small>
                                                                            {reward.codesArray.map((code, codeIndex) => (
                                                                                <div key={codeIndex} style={{fontFamily: 'monospace'}}>
                                                                                    {code}
                                                                                    {reward.pinsArray && reward.pinsArray[codeIndex] && (
                                                                                        <span className="text-muted"> (PIN: {reward.pinsArray[codeIndex]})</span>
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            );
                                        }, this)}
                                    </div>
                                ) : (
                                    <p>No prizes configured</p>
                                )}
                            </div>
                        )}
                    </ModalBody>
                </Modal>
       </div>
      );
    }
}

export default SetUpGame;
